<template>
  <div
    class="list-group-item fade"
    :class="{
      show: shown,
      'd-none': deleteProp,
    }"
  >
    <div v-if="bankverbindung">
      <div class="row">
        <div class="col-xl-2">
          <span
            v-if="editable"
            class="clickable mr-2"
            @click="$emit('bankverbindungAendern', index)"
          >
            <font-awesome-icon icon="fa-regular fa-pencil" />
          </span>
          {{ bankverbindung.bankverbindung }}
        </div>
        <div class="col-xl-2">{{ $t("global.account") }}: {{ bankverbindung.kontonummer }}</div>
        <div class="col-xl-2">{{ $t("global.iban") }}: {{ bankverbindung.iban }}</div>
        <div class="col-xl-2">{{ $t("global.bcnumber") }}: {{ bankverbindung.bc_nr }}</div>
      </div>
    </div>

    <font-awesome-icon
      icon="fa-regular fa-minus"
      class="delete-position-minus"
      v-if="editable"
    />
    <button
      v-if="editable"
      class="btn btn-danger deletePositionButton"
      @click="deleteBankverbindung"
    ></button>
  </div>
</template>

<script>
import { fadeIn } from "@/mixins/FadeIn";

export default {
  name: "Bankverbindung",
  components: {},
  mixins: [fadeIn],
  props: {
    bankverbindung: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      deleteProp: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    deleteBankverbindung() {
      this.shown = false;
      setTimeout(() => {
        this.$emit("deleteBankverbindung", this.index);
      }, 250);

      this.deleteProp = true;
    },

    openContextMenu() {
      this.$refs.ctxMenu.open();
    },
  },
};
</script>

<style>
</style>
